import React from 'react';

import { Button, ButtonTypes, StandardButton } from '@eika/button';
import ErrorCard, { ErrorCardProps } from '@eika/card/lib/ErrorCard';

import { useNavigate } from '@domain/app';
import useText from '@hooks/use-text';

interface CustomErrorCardProps extends ErrorCardProps {
    tryAgainClick?: () => void;
    hideBackToOverviewButton?: boolean;
}

const CustomErrorCardWithBackToOverview = ({ tryAgainClick, ...props }: CustomErrorCardProps) => {
    const { genericGoBackToCardList, genericTryAgain } = useText();
    const navigate = useNavigate();

    return (
        <ErrorCard {...props} isModal>
            <div className="error-container-buttons">
                <Button buttonType={ButtonTypes.STANDARD_NEGATIVE} onClick={navigate('HOME_PAGE')}>
                    {genericGoBackToCardList}
                </Button>
                {tryAgainClick && (
                    <StandardButton buttonType={ButtonTypes.STANDARD_NEGATIVE} onClick={() => tryAgainClick()}>
                        {genericTryAgain}
                    </StandardButton>
                )}
            </div>
        </ErrorCard>
    );
};

const CustomErrorCardWithoutBackToOverview = ({ tryAgainClick, ...props }: CustomErrorCardProps) => {
    const { genericTryAgain } = useText();

    if (!tryAgainClick) {
        return <ErrorCard {...props} isModal />;
    }

    return (
        <ErrorCard {...props} isModal>
            <div className="error-container-buttons">
                <StandardButton buttonType={ButtonTypes.STANDARD_NEGATIVE} onClick={() => tryAgainClick()}>
                    {genericTryAgain}
                </StandardButton>
            </div>
        </ErrorCard>
    );
};

const CustomErrorCard = ({ hideBackToOverviewButton = false, ...props }: CustomErrorCardProps) => {
    if (hideBackToOverviewButton) {
        return <CustomErrorCardWithoutBackToOverview {...props} />;
    }

    return <CustomErrorCardWithBackToOverview {...props} />;
};

export default CustomErrorCard;
